module.exports = "/assets/data/7fc34b7a5c11c3b8d48f928a740354e1-WS11.data.json";